<template>
  <div class="ACCOUNT">
    <div class="h5 text-bold m-b-2">Already have an account?</div>
    <div class="h5 m-b-2">Submit your request faster by signing in.</div>
    <button
        :disabled="disabled"
        class="btn-secondary w-100"
        @click="$emit('sign-in-clicked')">
      Sign In
    </button>
  </div>
</template>

<script>
export default {
  name: 'sign-in',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.ACCOUNT {
  @include padding(2);
  color: $color-gray70;
  border: 2px solid $color-gray30;
}
</style>
